module.exports = __webpack_public_path__ + "img/brackets_left_layout_icon.f22b3f79.svg";